<template>
  <v-menu
    offset-y
    :nudge-bottom="10"
    :max-width="300"
    :close-on-content-click="false"
    origin="center center"
    transition="scroll-y-transition"
    left
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" text small :class="[styleClass, selectedPortal && 'portalName' in selectedPortal ? '' : 'wave']">
        <span v-if="selectedPortal && 'portalName' in selectedPortal">{{ selectedPortal.portalName }}</span>

        <span v-else>Workspace</span>

        <v-icon v-if="icon" small class="ml-1">expand_more</v-icon>
      </v-btn>
    </template>

    <v-container :class="['envronment-menu-arrow-top pt-3', !icon && 'envronment-menu-arrow-top--no-icon']">
      <v-row class="d-flex flex-column pa-4">
        <v-combobox
          v-model="selectedEnvironment"
          class="mb-4"
          color="grey darken-3"
          :items="environments"
          label="Selecione o Ambiente"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          clearable
          append-icon="expand_more"
          @input="handleChangeEnvironment"
          @click:clear="clearEnvironment"
        />

        <v-combobox
          v-model="selectedPortal"
          class="mb-4"
          color="grey darken-3"
          :items="portals"
          label="Selecione o Portal"
          item-text="portalName"
          item-value="portalId"
          outlined
          dense
          hide-details
          clearable
          append-icon="expand_more"
          @input="handleChangePortal"
          @click:clear="clearPortal"
        />

        <v-combobox
          v-model="selectedModule"
          class="mb-4"
          color="grey darken-3"
          :items="modules"
          label="Selecione o Módulo"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          clearable
          append-icon="expand_more"
          @input="handleChangeModule"
          @click:clear="clearModule"
        />
      </v-row>
    </v-container>
  </v-menu>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import { INITIAL_SCHEMA } from '@/helpers/dev';
import { getPortals, getModulesByPortal } from '@/services/dev';

export default {
  props: {
    styleClass: { type: String, default: '', required: false },
    icon: { type: Boolean, default: true, required: false }
  },

  data: () => ({
    portals: [],
    modules: []
  }),

  events: {
    [HANDLERS.UPDATE_MODULES_DEV]: 'updateModules'
  },

  computed: {
    selectedEnvironment: {
      get() {
        return this.$store.getters['dev/getSelectedEnvironment'];
      },
      set(val) {
        this.$store.dispatch('dev/setSelectedEnvironment', val);
      }
    },

    selectedPortal: {
      get() {
        return this.$store.getters['dev/getSelectedPortal'];
      },
      set(val) {
        this.$store.dispatch('dev/setSelectedPortal', val);
      }
    },

    selectedModule: {
      get() {
        return this.$store.getters['dev/getSelectedModule'];
      },
      set(val) {
        this.$store.dispatch('dev/setSelectedModule', val);
      }
    },

    configLayout() {
      return this.$store.getters['dev/getConfigLayout'];
    },

    currentTemplate() {
      return this.$store.getters['dev/getCurrentTemplate'];
    },

    environments() {
      return this.$store.getters['dev/getEnvironments'];
    }
  },

  created() {
    this.getPortals(true);
    this.getModules();
  },

  methods: {
    clearEnvironment() {
      this.$store.dispatch('dev/clearMenus', []);
      this.$store.dispatch('dev/setSelectedItem', {});
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setPages', []);
      this.$store.dispatch('dev/setSelectedEnvironment', null);
      this.$store.dispatch('dev/setSelectedPortal', null);
      this.$store.dispatch('dev/setSelectedModule', null);
      this.selectedEnvironment = null;
      this.selectedPortal = null;
      this.selectedModule = null;
      this.portals = [];
      this.modules = [];
    },

    clearPortal() {
      this.$store.dispatch('dev/clearMenus', []);
      this.$store.dispatch('dev/setSelectedItem', {});
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setPages', []);
      this.$store.dispatch('dev/setSelectedPortal', null);
      this.$store.dispatch('dev/setSelectedModule', null);
      this.selectedPortal = null;
      this.selectedModule = null;
      this.modules = [];
    },

    clearModule() {
      this.$store.dispatch('dev/clearMenus', []);
      this.$store.dispatch('dev/setSelectedItem', {});
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setPages', []);
      this.$store.dispatch('dev/setSelectedModule', null);
      this.selectedModule = null;
    },

    async handleChangeEnvironment() {
      this.cleanPage();
      this.getPortals();
      this.clearModule();
    },

    async handleChangePortal() {
      this.cleanPage();
      this.getModules();
    },

    async handleChangeModule() {
      if (!this.selectedModule) return;

      this.cleanPage();
    },

    updateModules() {
      this.getModules();
    },

    async getPortals(created) {
      if (!this.selectedEnvironment) return;

      try {
        const { data } = await getPortals(this.selectedEnvironment.id);

        this.portals = data;

        this.$store.dispatch('dev/setSelectedEnvironment', this.selectedEnvironment);

        if (!created) {
          this.$store.dispatch('dev/setSelectedPortal', null);
          this.$store.dispatch('dev/setSelectedModule', null);
        }
      } catch (err) {
        this.portals = null;
      }
    },

    async getModules() {
      if (!this.selectedPortal) return;

      try {
        const { data } = await getModulesByPortal({
          environmentId: this.selectedEnvironment.id,
          idPortal: this.selectedPortal.portalId
        });

        this.modules = data;

        this.$store.dispatch('dev/setSelectedItem', {});

        if (this.currentTemplate === 'templateLayoutConfig') {
          await this.$store.dispatch('dev/getConfigLayout');

          for (let [key, value] of Object.entries(this.configLayout.theme)) {
            if (value !== '') {
              this.$vuetify.theme.themes.light[key] = value;
              this.$vuetify.theme.themes.dark[key] = value;
            }
          }
        }
      } catch (err) {
        this.modules = null;
      }
    },

    cleanPage() {
      if (this.currentTemplate === 'templateMenu') {
        this.$store.dispatch('dev/clearMenus', []);
        this.$store.dispatch('dev/setSelectedItem', {});
        this.$store.dispatch('dev/getMenus');
      }

      if (this.currentTemplate === 'templatePage') {
        this.$store.dispatch('dev/getPages');
        this.$store.dispatch('dev/setSchema');
        this.$store.dispatch('dev/setSelectedPage', '');
        this.$store.dispatch('dev/setPages', []);
        this.$store.dispatch('dev/setTypeOfPageEditing', '');
        this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));
      }

      if (this.currentTemplate === 'templateModule') {
        this.$store.dispatch('dev/setSelectedModule', null);
        this.selectedModule = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow-y: initial;
  overflow-x: initial;
  contain: none;
  background: #fff;
}

.envronment-menu-arrow-top {
  &:before {
    bottom: 100%;
    right: 48px;
    margin-left: -6px;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 6px;
    border-bottom-color: #fff;
  }

  &.envronment-menu-arrow-top--no-icon {
    &:before {
      right: 38px;
    }
  }
}
</style>
